import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-providers mb-0" }
const _hoisted_3 = { class: "align-middle" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "text-start align-middle" }
const _hoisted_6 = { class: "align-middle" }
const _hoisted_7 = ["onClick"]

import { ref, onMounted } from "vue";
import SubSection from '../common/SubSection.vue';
import { PensionProviderResponse } from "@/guiide/ts/response/pensionProviderResponse";

type ProviderPresentationData = {
    provider: PensionProviderResponse,
    formattedCharge: string,
    saving: string,
    savingColor: string
};


export default /*@__PURE__*/_defineComponent({
  __name: 'DIY',
  emits: ["back"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const providersPresentationData = ref(new Array<ProviderPresentationData>());

onMounted(() => {
    const hl: ProviderPresentationData = {
        provider: {
            "key": "HL",
            "name": "Hargreaves Lansdown",
            "description": "Those wanting to access a wide range of investments in their pension including ready-made solutions. Ongoing support 6 days a week by phone, email, or app, to help you manage your retirement income. You can also consider transferring other pensions.",
            "image": "/content/images/providers/hargreaves-logo.png",
            "url": "https://www.hl.co.uk/retirement/retirement-options-through-hl",
            "chargeForGeneralComparison": 44100,
            "chargeNoteGeneralComparison": "For Hargreaves Lansdown the platform charges are 0.45% p.a. for any pot value up to &pound;250,000 then 0.25% p.a. on each &pound;1 above &pound;250,000 to &pound;1,000,000, then 0.1% p.a. on each &pound;1 above &pound;1,000,000 to &pound;2,000,000, then zero on each &pound;1 above &pound;2,000,000. In addition, we have added 0.3% per annum at all pot sizes for the cost of their default investment fund for long term drawdown. Other lower cost funds are also available.",
            "chargeNotePersonalComparison": "For Hargreaves Lansdown; the platform charges are 0.45% p.a. for any pot value up to £250,000 then 0.25% p.a. on each £1 above £250,000 to £1,000,000, then 0.1% p.a. on each £1 above £1,000,000 to £2,000,000, then zero on each £1 above £2,000,000. In addition, we have added 0.24% per annum at all pot sizes for the cost of a Vanguard target dated retirement fund. Many other funds with lower or higher charges are also available on their platform.",
        },
        formattedCharge: "",
        saving: "",
        savingColor: ""
    };

    const ii: ProviderPresentationData = {
        provider: {
            "key": "II",
            "name": "ii",
            "description": "Those that want to keep more of their gains and income - a low flat fee for their award winning SIPP giving access to all types of investments. Only a few minutes to open an account and help to transfer existing pensions.",
            "image": "/content/images/providers/ii-logo.png",
            "url": "https://www.ii.co.uk/ii-partners/guiide?utm_source=guiide&utm_medium=affiliate&utm_campaign=sipp_main_page",
            "chargeForGeneralComparison": 22600,
            "chargeNoteGeneralComparison": "For Interactive Investor, the platform charges are £12.99 per month for funds over £50,000, £5.99 per month below £50,000. In addition there is a charge of £3.99 per month for each disinvestment to make a payment. We have assumed these fixed costs increase at 2% p.a. In addition, we have added 0.24% p.a at all pot sizes for the cost of a Vanguard target dated retirement fund. Many other funds with lower or higher charges are also available.",
            "chargeNotePersonalComparison": "For Interactive Investor, the platform charges are £12.99 per month for funds over £50,000, £5.99 per month below £50,000. In addition there is a charge of £3.99 per month for each disinvestment to make a payment. We have assumed these fixed costs increase at 2% p.a. In addition, we have added 0.24% p.a at all pot sizes for the cost of a Vanguard target dated retirement fund. Many other funds with lower or higher charges are also available."
        },
        formattedCharge: "",
        saving: "",
        savingColor: ""
    };    

    providersPresentationData.value.push(hl);
    providersPresentationData.value.push(ii);
});

function visitProvider(provider: PensionProviderResponse) {
    window.open(provider.url, "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "mt-5 mb-4" }, "Do it yourself", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("p", null, " For those who do not wish to seek advice and are comfortable they can manage their own sustainable withdrawal plan and wish to construct their own investment portfolio from a wide universe of options from various investment managers, individual shares and bonds this option is provided by a wide range of providers. Two of these providers who have given us permission to highlight their products are shown below although many more choices for a suitable provider exist. ", -1)),
    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mb-5" }, " To be clear if you decide to use one of these providers Guiide does not receive any referral payment. We have other commercial relationships with these and other providers but have no commercial interest in whether you decide to use them as a product provider. ", -1)),
    _createVNode(SubSection, {
      title: "Drawdown providers",
      "show-help": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Provider"),
                _createElementVNode("th", { class: "w-40" }, "Best suited to?"),
                _createElementVNode("th")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providersPresentationData.value, (providerPresentationData) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: providerPresentationData.provider.key
                }, [
                  _createElementVNode("td", _hoisted_3, [
                    _createElementVNode("img", {
                      src: providerPresentationData.provider.image,
                      class: "img-fluid",
                      alt: providerPresentationData.provider.name
                    }, null, 8, _hoisted_4)
                  ]),
                  _createElementVNode("td", _hoisted_5, _toDisplayString(providerPresentationData.provider.description), 1),
                  _createElementVNode("td", _hoisted_6, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-warning text-nowrap w-100",
                      onClick: ($event: any) => (visitProvider(providerPresentationData.provider))
                    }, " Visit " + _toDisplayString(providerPresentationData.provider.name), 9, _hoisted_7)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mt-5" }, "You can seek other providers on your own or get independent financial advice.", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", null, [
          _createTextVNode(" You can do this via our Advisers page, or go to "),
          _createElementVNode("a", {
            href: "https://www.moneyhelper.org.uk/",
            target: "_blank"
          }, "moneyhelper.org.uk"),
          _createTextVNode(" if you want more help on finding an adviser. ")
        ], -1))
      ]),
      _: 1
    }),
    _createElementVNode("button", {
      class: "btn btn-secondary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
    }, "Back")
  ], 64))
}
}

})